import { Container, Row, Col, Button } from 'react-bootstrap'
import { useState, useEffect } from 'react'

import apiService from '../services/ApiService'

import { FaRegNewspaper } from 'react-icons/fa'

function Noticias() {
  const [posts, setPosts] = useState([])

  const processImages = (imagesData) => {
    if (!imagesData) return []
    
    try {
      if (typeof imagesData === 'object' && !Array.isArray(imagesData)) {
        return Object.values(imagesData)
      }

      if (Array.isArray(imagesData)) {
        return imagesData
      }

      const parsed = JSON.parse(imagesData)
      return Object.values(parsed)
    } catch (error) {
      console.error('Erro ao processar images:', error)
      return []
    }
  }

  useEffect(() => {
    const fetchPosts = async () => {
      const websiteId = Number.parseInt(process.env.REACT_APP_WEBSITE_ID, 10)
      const fetchedPosts = await apiService.getPosts(websiteId)

      if (!fetchedPosts) return

      const processedPosts = fetchedPosts
      .filter(post => post.status === 'published')
      .map(post => ({
        ...post,
        images: processImages(post.images)
      }))

      setPosts(processedPosts)
    }
    fetchPosts()
  }, [])

  return (
    <Container>
      <Row className='mt-3'>
        <Col>
          <Row>
            <Col xs={12}>
              <h2 className="section-title">
                <FaRegNewspaper /> NOTÍCIAS
              </h2>
            </Col>
          </Row>
          {posts.map((post) => (
            <div key={post.id} className="post-card">
              <Row className="g-0">
                <Col xs={12} md={3}>
                  {post.images
                    .filter(image => image.cover)
                    .map((image, imgIndex) => (
                      <div key={imgIndex} className="post-card-image-wrapper">
                        <img
                          src={`${process.env.REACT_APP_CDN}/${process.env.REACT_APP_IMAGE_BUCKET}/${image.name}`}
                          alt={post.title}
                          className="post-card-image"
                        />
                      </div>
                  ))}
                </Col>
                <Col xs={12} md={9} className="p-4 d-flex flex-column">
                  <h5 className="fw-bold mb-2">{post.title}</h5>
                  <div
                    className="flex-grow-1 text-muted"
                    style={{ textAlign: 'justify', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 1 }}
                    dangerouslySetInnerHTML={{ __html: post.text }}
                  />
                  <div>
                    <Button className="btn-primary-red border-0" href={'noticias/' + post.slug}>
                      Ler matéria completa
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  )
}

export default Noticias